import React, {Fragment, isValidElement, FunctionComponent, ReactElement} from 'react';
import './List.less';
import {ListSplitter} from 'elements/list-splitter/ListSplitter.tsx';

interface ListProps {
	isModal?: boolean
	isSplitterPadding?: boolean
}

//TODO use column flex layout
export const List: FunctionComponent<ListProps> = ({children, isModal = false, isSplitterPadding}) => {
	return (<ul className={`list ${isSplitterPadding ? 'list--splitter-padding' : ''}`}>
		{
			Array.isArray(children) && (children as Array<ReactElement>).filter(child => isValidElement(child)).map((child, index) =>
				<Fragment key={child.key}>
					{index > 0 && <ListSplitter isAlignByContainer isModal={isModal}/>}
					{child}
				</Fragment>)
		}
	</ul>);
};
